import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/viewblog.css'
import Helmet from '../components/Helmet/Helmet'
import Gc from '../components/Gc/Gc'

import BlogImage from '../assets/images/DSC_5304-4-copy-THUMBNAIOL-copy-2048x1463.webp'
import DSC_5290 from '../assets/images/DSC_5290-copy-1536x1024.jpg'
import DSC_5270 from '../assets/images/DSC_5270-copy-1536x1038.jpg'
import DSC_5297 from '../assets/images/DSC_5297-2-copy.jpg'

import arrowI from '../assets/icons/arrow-right-s-line.svg'
import facebook from '../assets/icons/facebook.png'
import pinterest from '../assets/icons/pinterest.png'
import x from '../assets/icons/x.png'


const items = [
  { xs: 4, imgSrc: DSC_5290 },
  { xs: 4, imgSrc: DSC_5270 },
  { xs: 4, imgSrc: DSC_5297 },

];

const Frogstarry_blog = () => {

    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank');
      };
    
      const shareOnPinterest = () => {
        window.open(`https://www.pinterest.com/pin/create/button/?url=${window.location.href}&media=${BlogImage}`, '_blank');
      };
    
      const shareOnX = () => {
        window.open('https://www.x.com/share?url=' + encodeURIComponent(window.location.href), '_blank');
      };

  return <Helmet title={'The worlds rarest frog,Starry shrub frog(Pseudophilautus stellatus)'}>
  <section className='view__blog __black'>
  <div className="w-1">
      <div className='blog__socialmedia-main'>
        <div className="blog__socialmedia-bar">
          <span>share:</span>
          <button onClick={shareOnFacebook}><img src={facebook} alt="facebook" /></button>
          <button onClick={shareOnPinterest}><img src={pinterest} alt="pinterest" /></button>
          <button onClick={shareOnX}><img src={x} alt="x" /></button>
        </div>
        <h1>The worlds rarest frog,Starry shrub frog(Pseudophilautus stellatus)</h1>
        <span className='dash'></span>
      </div>
      <div>
          <img src={BlogImage} alt="" />
          <p>This frog was first recognized by E.F Kelaart from a single specimen,and was described as a new species. After that,it was lost for more than 157 years and was announced as an extinct frog.In 2013, Mendis Wickramasinghe, Dulan Ranga Vidanapathirana and their team published the rediscovery of this frog from Sri paada sanctuary, and they dubbed it as the worlds most elusive amphibian, since it was lost for nearly 160 years, without a specimen, photograph or a drawing.</p>
      </div>
      <Gc style={{height:'65vh'}} items={items} />
      <div className='view__blog-details'>
          <ul className='view__blog-ul'>
            <li>It is the first shrub frog to be named from sri lanka</li>
            <li>The amphibian that remained lost for the longest amount of time(157 years)</li>
            <li>Since 2013, no specimen, photograph or a drawing was available for this frog</li>
            <li>The only green shurb frog that grows for more than 5cm.</li>
            <li>The unique colour pattern(No other amphibian of sri lanka has this colour pattern) Canopy dwelling amphibian.</li>
            <li>A highly seasonal frog Dorsally this frog is green in colour and has numerous pinkish white spots wuth black margins, hence the name “Starry”</li>
          </ul>
      </div>
      <p>The shank laterally has tiger like stripes.Eyes are green in colour and it was the only frog with green eyes i have seen in Sri lanka.(Should be clarified) This is an canopy dwelling species that was found from 1-10m heights in trees, this particular frog in the picture was found approximately 5m from the ground.Because of the colour pattern it is very well camouflaged in the leaves,making it more harder to find.This frog rarely jumps,but prefer walking instead.The breeding behavior of this frog is not observed and it is an interesting topic.</p>
      <hr />
      <Link className='previous_blog' to='/blog'><img src={arrowI} alt="" />previous post</Link>
  </div>
</section>
</Helmet>
}

export default Frogstarry_blog